import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardMembership } from '@material-ui/icons';
import CertificatesForStudent from '../List';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';
import {
  Button,
} from '@material-ui/core';


const ProfileCertificates = () => {
  const classes = useStyles();
  const { t } = useTranslation([ 
    'title',
    'form',
    'button',
    'validation',
    'toastify',
    'label',
  ]);
  const { id_company } = useSelector((state) => state.auth);
  

  const handleClick = () => {
    window.open('https://crescamais.tawk.help/article/validade-de-certificados', '_blank');
  }


  return (
    <div className={classes.root}>
      <div>
        {id_company !== '4b44b51e-c4d0-4209-9fcb-1db56f09b036' && (
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    color="primary"
                    variant="outlined"
                    startIcon={<CardMembership />}
                    target="_blank"
                    onClick={handleClick}
                  >
                    {t('button:User.btn_certificate_validity')}
                  </Button>
                </div>
              )}
      </div>
      <div className={classes.content}>
        <CertificatesForStudent />
      </div>
    </div>
  );
};

export default ProfileCertificates;

